<template>
    <div>
        <div v-if="format == 'small'">
            <p>{{notifications.length}} notification{{notifications.length > 1 ? "s" : ""}}</p>
            <div v-for="(notification, idx) in notifications.slice(0, 10)" :key="idx">
                {{moment.utc(notification.date).local().fromNow()}} : {{notification.data.text || notification.data}} <b-button @click="delete_notifications(notification.uid)" variant="link" size="sm"><i style="color:red" class="fas fa-trash"></i></b-button>
            </div>
        </div>
        <div v-else>
            <div v-for="(notification, idx) in notifications" :key="idx">
                {{moment(notification.date).fromNow()}} : {{notification.data.text}} <b-button @click="delete_notifications(notification.uid)" variant="link" size="sm"><i style="color:red" class="fas fa-trash"></i></b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    import messages_services from "../../services/messages.js";

    var clone = require("clone");

    export default {
        props: {
            format: {
                default: "small"
            },
            test_jwt: {
                default: null
            }
        },
        data: function () {
            return {
                notifications: []
            };
		},
        event: async function (event) {
            console.log(event)
            if (event.type == "notifications" || event.type == "notification")
            {
                this.notifications = [];
                this.notifications = await messages_services.list("notification", this.test_jwt)
                this.notifications = this.notifications.messages

                for (var i = 0; i < this.notifications.length; i++)
                {
                    this.notifications[i].data = JSON.parse(this.notifications[i].data)
                }
            }
		},
		methods: {
			async delete_notifications(uid)
			{
				console.log("delete_notifications " + uid)
				for (var i = 0; i < this.notifications.length; i++)
                {
                    if (this.notifications[i].uid == uid)
                    {
						console.log(this.notifications[i])
                        await messages_services.delete(this.notifications[i].uid)
                        this.notifications.splice(i, 1);
                        i--;
                    }
                }
            },
            
            async load(data)
            {
                this.data = data;

                this.notifications = await messages_services.list("notification", this.test_jwt)
                if (this.notifications && this.notifications.messages)
                {
                    this.notifications = this.notifications.messages

                    for (var i = 0; i < this.notifications.length; i++)
                    {
                        this.notifications[i].data = JSON.parse(this.notifications[i].data)
                    }
                }
                else
                {
                    this.notifications = []
                }
            }
		},
		mounted: function () {
            this.timer = setInterval(() => {10
				var notifications = clone(self.notifications);
				self.notifications = [];
				self.notifications = notifications;

			}, 60000)
		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
    }


</script>